import React from "react";
import "./Input.css";

const Input = ({
	type,
	name,
	value,
	onChange,
	label,
	min = "",
	max = "",
	step = "",
	readOnly = false,
	nonReadOnlyStyle = false,
	required = false,
	minLength = "",
	style = {}
}) => {
	const hasData = value || value === 0;
	return (
		<div
			style={style}
			className={`Input-container ${hasData ? "has-data" : ""} ${
				readOnly && !nonReadOnlyStyle ? "readonly" : ""
			}`}
		>
			<input
				type={type}
				name={name}
				value={value}
				onChange={onChange}
				min={min}
				max={max}
				step={step}
				readOnly={readOnly}
				required={required}
				minLength={minLength}
			/>
			<label>{label}</label>
		</div>
	);
};

export default Input;
